import React from 'react';
import { connect } from 'react-redux';
import pageMenuTemplate from '../../../templates/Stones/AssignPricing/menu.rt';
import * as actions from '../../../actions';
import {AccessRights} from './../../../schemas/accessRightsModel';

function mapStateToProps(state) {
  return {
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showAssignPricing: () => dispatch(actions.pricingPresets.showAssignPricing(true))
  };
}

class stoneAssignPricingMenu extends React.Component {
  render = pageMenuTemplate;
}

const connector = connect(mapStateToProps, mapDispatchToProps);

const StoneAssignPricingMenu = connector(stoneAssignPricingMenu);

export default StoneAssignPricingMenu;
export { StoneAssignPricingMenu };
